import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import CatalogoCatProgramatica from "../../catalogos/catalogoCategoriaProgramatica";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import moment from "moment";
import axios from "axios";

export const ImpEjeFinanciera = (props) => {
  // --- UTILIDADES ---
  let op = require("../../../src/modulos/datos"); // Asegúrate de que esta ruta sea correcta
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const post = JSON.parse(localStorage.getItem("post"));
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [mostrar3, setMostrar3] = useState(false);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  // --- REFS UTILIZADOS ---
  const txt1 = useRef(); // Sector
  const txt2 = useRef(); // Prog
  const txt3 = useRef(); // SubProg
  const txt4 = useRef(); // Proy
  const txt5 = useRef(); // Act
  const btnCat = useRef();

  const checkResumenRef = useRef(); // Checkbox "Solo Alcadia"

  const fechaHastaRef = useRef();
  const tipoCompromisoRef = useRef();

  // --- ESTADOS ---
  const [modoProveedor, setModoProveedor] = useState('seleccionar'); // 'seleccionar' o 'todos'

  // --- DATA UTILIZADA ---
  // NOTA: Para que la lógica sql3 funcione igual que en Java (puc = '...'), 
  // las opciones aquí deberían contener códigos PUC o el label ser el código.
  /* const opcionesCompromiso = [
    { value: "0", label: "TODAS" }, // Índice 0 = true
    { value: "1", label: "401010100 - Gastos Corrientes" }, // Ejemplo de código PUC
    { value: "2", label: "402010100 - Gastos Capital" }
  ]; */

  const [opcionesCompromiso, setOpcionesCompromiso] = useState([]);

  const titulo = {
    109: 'Partidas x Orden de Pago',
    110: 'Partidas x Orden de Pago (Cuenta PUC)',
  };

  useEffect(() => {
    // seleccionarPartidas();
  }, []);

  const seleccionarPartidas = () => {
    
    let endpoint;
    if (props.reporte === 109) {
      endpoint = `${op.conexion}/api/administracion/partida1?idefiscal=${idefiscal}&tipo=1`
    } else {
      endpoint = `${op.conexion}/api/administracion/partida1?idefiscal=${idefiscal}&tipo=2`
    }

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let data = [];
            for (let i = 0; i < response.data.length; i++) {
              data.push({
                value: i,
                label: response.data[i].partida,
              });
            }
            setOpcionesCompromiso(data);
          } 
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

      });
  };

  const cerrar = () => {
    props.cancelar();
  };

  const catalogoCat = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const handleAceptaCatProgramatica = (
    idcategoriaprogramatica,
    descripcion,
    categoriaprogramatica
  ) => {
    setMostrar3(false);

    if (categoriaprogramatica && txt1.current) {
      txt1.current.value = categoriaprogramatica.substring(0, 2);
      txt2.current.value = categoriaprogramatica.substring(2, 4);
      txt3.current.value = categoriaprogramatica.substring(4, 6);
      txt4.current.value = categoriaprogramatica.substring(6, 8);
      txt5.current.value = categoriaprogramatica.substring(8, 10);
    }
  };

  const handleChangeModoProveedor = (nuevoModo) => {
    setModoProveedor(nuevoModo);
    if (nuevoModo === 'todos' && txt1.current) {
      txt1.current.value = '';
      txt2.current.value = '';
      txt3.current.value = '';
      txt4.current.value = '';
      txt5.current.value = '';
    }
  };

  // --- FUNCIÓN IMPRIMIR ---
  const imprimir = () => {
    //if (props.reporte === 109) {
      try {
        let idEfi = idefiscal;
        let tit = titulo[props.reporte] || 'Reporte';
        let org = post.nombreorg;

        // --- 1. VALIDACIONES (ValidarCampos33) ---
        let fHasta = fechaHastaRef.current.value;

        if (!fHasta) {

          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Introducir la Fecha de Inicio (Hasta la Fecha).",
            icono: "informacion",
          });
          return;
        }

        // Si está en modo seleccionar, validamos que tenga una categoría cargada (validando txt2 'Prog')
        if (modoProveedor === 'seleccionar') {
          if (!txt2.current || txt2.current.value.trim() === "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Debe Introducir Una Categoria Programatica",
              icono: "informacion",
            });
            return;
          }
        }

        // --- 2. FORMATEO DE FECHAS ---
        // Java: val3 es la fecha Hasta. val2 es fija 01-01-AÑO.
        let partsHasta = fHasta.split('-');
        // Input type=date devuelve YYYY-MM-DD. Convertimos a DD-MM-YYYY para Jasper
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];
        let val2 = "01-01-" + partsHasta[0]; // Inicio de año fijo

        // --- 3. CONSTRUCCIÓN DE SQLs ---

        // sql3: Partida (Combo)
        // Lógica Java: si índice 0 -> "and true", sino "AND puc = '"+ texto.substring(0,9)+"'"
        let sql3 = "";
        let indexPartida = tipoCompromisoRef.current.selectedIndex;
        if (indexPartida === 0) {
          sql3 = " and true";
        } else {
          // Asumimos que el texto del option es el código PUC como en el Java original
          let textoPartida = tipoCompromisoRef.current.options[indexPartida].text;
          // Tomamos los primeros 3 caracteres del código
          if (props.reporte === 109) {
            sql3 = " AND SUBSTR(puc,1,3) = '" + textoPartida.substring(0, 3) + "' ";
          } else {
            sql3 = " AND puc = '" + textoPartida.substring(0, 9) + "' ";
          }
        }

        // sql2: Categoría (Radio Buttons)
        // Lógica Java: 
        // radioButton (Seleccionar) -> "AND Categoria = '...'"
        // radioButton1/radioButton11 (Todos/General) -> "AND Categoria >= '0'"
        let sql2 = "";
        if (modoProveedor === 'seleccionar') {
          // Concatenamos los inputs txt1..txt5
          let cat = txt1.current.value + txt2.current.value + txt3.current.value + txt4.current.value + txt5.current.value;
          sql2 = " AND Categoria = '" + cat.trim() + "'";
        } else {
          // 'todos'
          sql2 = " AND Categoria >= '0' ";
        }

        // sql4: Solo Alcaldía (Checkbox)
        // Lógica Java: chkSolo.getSelection() ? " AND alcaldia = true" : " AND TRUE"
        let sql4 = checkResumenRef.current.checked ? " AND alcaldia = true" : " AND TRUE";

        // SQL PRINCIPAL
        // Java: sql = " MOVIMIENTO.FECHA <= '" + val3 + "'" + sql2 + sql3 + sql4;
        let sql = " MOVIMIENTO.FECHA <= '" + val3 + "'" + sql2 + sql3 + sql4;

        // --- 4. NOMBRE DEL ARCHIVO (Jasper) ---
        // Lógica Java basada en RadioButton11 (General) vs Específico y Espíritu
        let fileName = "";
        if (props.reporte === 109) {
          fileName = "Pres_CuentasxOrden2NumOrden";
        } else {
          if (modoProveedor === 'general') {
            // Equivalente a radioButton11 (General) en Java
            fileName = "Pres_CuentasxOrden2CuentaGen";
          } else {
            fileName = "Pres_CuentasxOrden2NumOrdenCuenta";

          } 
        }

        // --- 5. PARÁMETROS Y APERTURA ---
        let condicionCompleta = sql.trim();
        let sql2_texto = val3.replace("-", "/"); // TIT_RGO1 es la fecha formateada

        window.open(
          op.reportes + "/administracionTesoreria?" + // Ajusta la ruta si es necesario
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2_texto) +
          "&PARTIDA=" + encodeURIComponent("0") + // Java envía "0" fijo aquí
          "&RGO_FCHINI=" + encodeURIComponent("'" + val2.trim() + "'") +
          "&RGO_FCHFIN=" + encodeURIComponent("'" + val3.trim() + "'") +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);

        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Mensaje de Error: " + error.message,
          icono: "informacion",
        });
      }
    //}     // --- REPORTE 110: Analitico / Partidas por Orden de Pago (tiporep 58) ---
    /* else if (props.reporte === 110) {
      try {
        let idEfi = idefiscal;
        let tit = titulo[props.reporte] || 'Reporte';
        let org = post.nombreorg;

        // --- 1. VALIDACIONES ---
        let fHasta = fechaHastaRef.current.value;

        if (!fHasta) {

          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Introducir la Fecha de Inicio (Hasta la Fecha)",
            icono: "informacion",
          });
          return;
        }

        // Si está en modo seleccionar, validamos que tenga una categoría cargada
        // Java: if (txtPrograma.getText().trim().equals("") && radioButton.getSelection() == true)
        if (modoProveedor === 'seleccionar') {
          if (!txt2.current || txt2.current.value.trim() === "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Debe Introducir Una Categoria Programatica",
              icono: "informacion",
            });

            return;
          }
        }

        // --- 2. FORMATEO DE FECHAS ---
        // Java: val3 es la fecha Hasta, val2 es fija 01-01-AÑO
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0]; // DD-MM-YYYY
        let val2 = "01-01-" + partsHasta[0]; // 01-01-YYYY

        // --- 3. CONSTRUCCIÓN DE SQLs ---

        // sql3: Partida (Combo cmbTipoComp)
        // Java: cmbTipoComp.getSelectionIndex() == 0 ? " and true" : " AND puc = '"+ texto.substring(0,9)+"'"
        let sql3 = "";
        let indexPartida = tipoCompromisoRef.current.selectedIndex;
        if (indexPartida === 0) {
          sql3 = " and true";
        } else {
          // NOTA: El label del option debe contener el código PUC al inicio
          let textoPartida = tipoCompromisoRef.current.options[indexPartida].text;
          sql3 = " AND puc = '" + textoPartida.substring(0, 9) + "' ";
        }

        // sql2: Categoría (Radio Buttons)
        // radioButton (Seleccionar) -> "AND Categoria = '...'"
        // radioButton1 (Todas) / radioButton11 (General) -> "AND Categoria >= '0'"
        // En el UI React actual solo existe 'seleccionar' y 'todos'.
        let sql2 = "";
        if (modoProveedor === 'seleccionar') {
          // Concatenamos los inputs txt1..txt5 (Sector, Prog, SubProg, Proy, Act)
          let cat = txt1.current.value + txt2.current.value + txt3.current.value + txt4.current.value + txt5.current.value;
          sql2 = " AND Categoria = '" + cat.trim() + "'";
        } else {
          // 'todos' equivale a radioButton1 o radioButton11
          sql2 = " AND Categoria >= '0' ";
        }

        // sql4: Solo Alcaldía
        // Java: chkSolo.getSelection() ? " AND alcaldia = true" : " AND TRUE"
        let sql4 = checkResumenRef.current.checked ? " AND alcaldia = true" : " AND TRUE";

        // SQL PRINCIPAL
        // Java: sql = " MOVIMIENTO.FECHA <= '" + val3 + "'" + sql2 + sql3 + sql4;
        let sql = " MOVIMIENTO.FECHA <= '" + val3 + "'" + sql2 + sql3 + sql4;

        // --- 4. NOMBRE DEL ARCHIVO (Jasper) ---
        // Lógica Java basada en radioButton11 (General) vs Específico
        // Como no tenemos radioButton11 en el UI React, asumiremos el reporte Específico
        let fileName = "Pres_CuentasxOrden2NumOrdenCuenta";


        // --- 5. PARÁMETROS Y APERTURA ---
        // Asegúrate que la ruta sea correcta, aquí asumí "/administracionPresupuesto"
        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(sql.trim()) +
          "&TIT_RGO1=" + encodeURIComponent(val3.replace("-", "/")) +
          "&PARTIDA=" + encodeURIComponent("0") +
          "&RGO_FCHINI=" + encodeURIComponent("'" + val2.trim() + "'") +
          "&RGO_FCHFIN=" + encodeURIComponent("'" + val3.trim() + "'") +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);


        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Introducir Una Categoria Programatica",
          icono: "informacion",
        });

      }
    } */
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarPartidas();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          {titulo[props.reporte]}
        </h3>
        <button className="btn btn-sm bg-light" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12 row mx-auto px-0">

          {/* Buscar Por */}
          <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded row">
            <legend className="float-none text-uppercase w-auto m-0">Buscar Por</legend>

            <div className="col-md-12 mx-auto row my-auto py-0">
              <div className="input-group input-group-sm col-md-5 mb-0">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Hasta la Fecha:</span>
                <input
                  ref={fechaHastaRef}
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                />
              </div>
            </div>
          </fieldset>

          {/* Select Partida */}
          <div className="input-group input-group-sm col-md-12 mx-auto mb-1 px-0 mt-2">
            <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Partida :</span>
            <select
              ref={tipoCompromisoRef}
              className="form-select"
              aria-label="Default select example"
            >
              {opcionesCompromiso.map((op) => (
                <option key={op.value} value={op.value}>
                  {op.label}
                </option>
              ))}
            </select>
          </div>

          {/* Selección de Categoría vs Todas */}
          <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
            <div className="col-md-4 row mx-auto mb-2">
              <div className="form-check my-auto">
                <input
                  className="form-check-input text-uppercase my-auto"
                  type="radio"
                  name="radioProveedor"
                  id="radioProvSelect"
                  checked={modoProveedor === 'seleccionar'}
                  onChange={() => handleChangeModoProveedor('seleccionar')}
                />
                <label className="form-check-label text-uppercase my-auto" htmlFor="radioProvSelect">
                  Selecionar Categoria
                </label>
              </div>
            </div>

            <div className="col-md-4 row mx-auto mb-2">
              <div className="form-check my-auto">
                <input
                  className="form-check-input text-uppercase my-auto"
                  type="radio"
                  name="radioProveedor"
                  id="radioProvTodos"
                  checked={modoProveedor === 'todos'}
                  onChange={() => handleChangeModoProveedor('todos')}
                />
                <label className="form-check-label text-uppercase my-auto" htmlFor="radioProvTodos">
                  Todas las Categorias
                </label>
              </div>
            </div>

            {props.reporte === 110 ? <div className="col-md-4 row mx-auto mb-2">
              <div className="form-check my-auto">
                <input
                  className="form-check-input text-uppercase my-auto"
                  type="radio"
                  name="radioProveedor"
                  id="radioProvTodos"
                  checked={modoProveedor === 'general'}
                  onChange={() => handleChangeModoProveedor('general')}
                />
                <label className="form-check-label text-uppercase my-auto" htmlFor="radioProvTodos">
                  General
                </label>
              </div>
            </div> : ''}

            <div className="col-md-12 row mx-auto px-0 mb-2">
              <div className="form-check col-md-3 ml-auto">
                <input
                  ref={checkResumenRef}
                  className="form-check-input text-uppercase"
                  type="checkbox"
                  value=""
                  id="checkDefault"
                />
                <label className="form-check-label text-uppercase text-uppercase fw-bold" htmlFor="checkDefault">
                  Solo Alcadia
                </label>
              </div>
            </div>
          </div>

          {/* Categoría Programática - Se muestra solo si modoProveedor es 'seleccionar' */}
          {modoProveedor === 'seleccionar' && (
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-end border-azul rounded mx-auto mt-2">
              <legend className="float-none m-0 w-auto ">
                Categoria Programatica
              </legend>

              <div className="input-group input-group-sm col-md-12 mb-1">
                <table className="col-11 mb-1 table table-responsive px-0 border">
                  <thead>
                    <tr>
                      <th className="text-center" scope="col">Sector</th>
                      <th className="text-center" scope="col">Prog</th>
                      <th className="text-center" scope="col">SubProg</th>
                      <th className="text-center" scope="col">Proy</th>
                      <th className="text-center" scope="col">Act</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          disabled={true}
                          maxLength="2"
                          name="uno"
                          ref={txt1}
                          className="form-control text-uppercase mr-1 text-center"
                          id="inputLogin"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          disabled={true}
                          maxLength="2"
                          name="dos"
                          ref={txt2}
                          className="form-control text-uppercase mr-1 text-center"
                          id="inputLogin"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          disabled={true}
                          maxLength="2"
                          name="tres"
                          ref={txt3}
                          className="form-control text-uppercase mr-1 text-center"
                          id="inputLogin"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          disabled={true}
                          maxLength="2"
                          name="cuatro"
                          ref={txt4}
                          className="form-control text-uppercase mr-1 text-center"
                          id="inputLogin"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          disabled={true}
                          maxLength="2"
                          name="cinco"
                          ref={txt5}
                          className="form-control text-uppercase text-center"
                          id="inputLogin"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="col d-flex">
                  <button
                    ref={btnCat}
                    onClick={catalogoCat}
                    className="btn btn-sm btn-info my-auto mx-auto rounded-circle"
                  >
                    <i className="fa fa-search"></i>{" "}
                  </button>
                </div>
              </div>
            </fieldset>
          )}

        </div>

        <Mensaje mensaje={mensaje}
          onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />

        <CatalogoCatProgramatica
          show={mostrar3}
          onHideCancelar={handleCancelara}
          onHideAceptaCatProgramatica={handleAceptaCatProgramatica}
        />

      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-sm btn-primary text-uppercase" onClick={imprimir}>
          <i className="fas fa-print me-2"></i> Imprimir
        </button>
        <button className="btn btn-sm btn-secondary text-uppercase" onClick={cerrar}>
          <i className="fas fa-times me-2"></i> Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};